"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectKnowledge = void 0;
var ConnectNodeKnowledge_1 = require("./ConnectNodeKnowledge");
var ConnectKnowledge = /** @class */ (function (_super) {
    __extends(ConnectKnowledge, _super);
    function ConnectKnowledge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "ConnectKnowledge";
        _this.node = function (nodeId, config) { return _this.push(function (registry) {
            var name1 = registry.register("nodeId", nodeId);
            var entity = new ConnectNodeKnowledge_1.ConnectNodeKnowledge();
            config(entity);
            return "node(nodeId:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return ConnectKnowledge;
}(Array));
exports.ConnectKnowledge = ConnectKnowledge;
//# sourceMappingURL=ConnectKnowledge.js.map